const topics = [
  { name: '古装剧推荐', count: '128万讨论', hot: true },
  { name: '2026暑期档', count: '96万讨论', hot: true },
  { name: '悬疑探案', count: '87万讨论', hot: true },
  { name: '韩剧热播', count: '73万讨论', hot: false },
  { name: '高分美剧', count: '65万讨论', hot: false },
  { name: '治愈日剧', count: '52万讨论', hot: false },
  { name: '大结局倒计时', count: '48万讨论', hot: true },
  { name: '新剧开播', count: '41万讨论', hot: false },
  { name: '4K画质', count: '35万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-hashtag text-sm w-4 h-4 flex items-center justify-center"></i>
            热门话题
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">大家都在讨论</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">剧迷社区最火热的话题标签，看看大家都在追什么、聊什么。</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-colors ${
                topic.hot
                  ? 'bg-accent-50 border-accent-200 hover:border-accent-400'
                  : 'bg-background-100 border-background-200/60 hover:border-primary-200'
              }`}
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                </span>
              )}
              <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}